// One asset contains one generation technology, optionally paired with storage.
export const ASSET_TYPES = [
  { value: "Standalone PV", label: "Standalone PV", hasPv: true, hasWind: false, hasBess: false },
  { value: "Standalone BESS", label: "Standalone BESS", hasPv: false, hasWind: false, hasBess: true },
  { value: "Hybrid", label: "Hybrid PV (PV + BESS)", hasPv: true, hasWind: false, hasBess: true },
  { value: "Wind", label: "Standalone Wind", hasPv: false, hasWind: true, hasBess: false },
  { value: "Hybrid Wind", label: "Hybrid Wind (Wind + BESS)", hasPv: false, hasWind: true, hasBess: true },
];

export function assetTypeDefinition(value) {
  const key = String(value || "").trim().toLowerCase();
  return ASSET_TYPES.find((t) => t.value.toLowerCase() === key) || null;
}

export function deriveProjectAssets(cfg) {
  const type = assetTypeDefinition(cfg?.systemType);
  return { hasPv: Boolean(type?.hasPv), hasWind: Boolean(type?.hasWind) };
}

export function assetTypeIssue(cfg) {
  const type = assetTypeDefinition(cfg?.systemType);
  if (!type) return "Choose an asset type. PV and wind must be configured as separate assets.";
  if (!type.hasWind && cfg?.wind?.enabled) return "This asset combines PV or BESS with wind. Create separate PV and wind assets, then choose a type for each.";
  return "";
}

export const PV_ONLY_STUDY_ERROR = "Standalone PV studies currently support Behind-the-Meter only. Select Behind-the-Meter; other revenue models are not yet supported without a battery.";

export function studyAssetIssue(cfg) {
  const type = assetTypeDefinition(cfg?.systemType);
  if (type?.value === "Standalone PV") {
    return String(cfg?.settlementType || "").trim().toUpperCase() === "BTM" ? "" : PV_ONLY_STUDY_ERROR;
  }
  return type?.hasBess === false
    ? "This study workflow requires BESS. Use Weather & Generation for this standalone asset’s generation calculations."
    : "";
}

export function applyAssetType(config, value) {
  const type = assetTypeDefinition(value);
  if (!type) throw new Error("Choose an asset type before creating the asset.");
  return {
    ...config,
    systemType: type.value,
    wind: { ...(config?.wind || {}), enabled: type.hasWind },
    ...(!type.hasPv ? { pvInstalledCap: { ...(config?.pvInstalledCap || {}), kw: 0 } } : {}),
    ...(!type.hasBess ? { bess: { ...(config?.bess || {}), selected: [], activeName: "" } } : {}),
  };
}
